import { form } from '../../formState'
import { useTexts } from './useTexts'

export function SummarizeFutureMobileRoute() {
  const texts = useTexts()

  return (
    <form.Checkbox
      name="summarizeFutureMobileRoute"
      testId="summarizeFutureMobileRoute"
      label={texts.summarizeFutureMobileRoute}
      validateOn="change"
      helperText={texts.summarizeFutureMobileRouteHelper}
    />
  )
}
